import { createFileRoute } from '@tanstack/react-router';
import { CarriersPage } from '@/features/carriers/list/carriers-page';

// S10 · Carriers list (07 §4); M10 on the phone.
export const Route = createFileRoute('/_app/carriers/')({
  component: CarriersPage,
});
